import { experience } from "../data";
import { Reveal, Section, TagList } from "./ui";

export function Experience() {
  return (
    <Section
      id="experience"
      title="Experience"
      intro="Where I've worked, and what the work actually taught me."
    >
      <ol className="relative space-y-10">
        {experience.map((job) => (
          <li key={job.org} className="relative pl-10 sm:pl-14">
            {/* timeline rail */}
            <span
              aria-hidden="true"
              className="absolute top-3 left-[7px] h-[calc(100%+2.5rem)] w-px bg-gradient-to-b from-blush/70 via-orchid/40 to-transparent sm:left-[11px]"
            />
            <span
              aria-hidden="true"
              className="absolute top-2.5 left-0 grid h-4 w-4 place-items-center rounded-full bg-midnight shadow-[0_0_0_1px_rgba(235,166,198,0.6)] sm:left-1"
            >
              <span className="h-1.5 w-1.5 rounded-full bg-blush" />
            </span>

            <Reveal>
              <div className="glass leaf-tr p-7 sm:p-8">
                <div className="flex flex-wrap items-baseline justify-between gap-x-6 gap-y-1">
                  <h3 className="text-display text-[1.5rem] text-porcelain">{job.role}</h3>
                  <span className="text-[0.8rem] text-faint">{job.period}</span>
                </div>
                <p className="mt-1.5 text-[0.92rem] text-orchid/90">
                  {job.org} · {job.place}
                </p>

                <p className="mt-5 max-w-[60ch] leading-relaxed text-mist">{job.summary}</p>

                <ul className="mt-6 space-y-3">
                  {job.points.map((point) => (
                    <li key={point} className="flex gap-3 leading-relaxed text-mist/90">
                      <span
                        aria-hidden="true"
                        className="mt-[0.65em] h-1 w-1 shrink-0 rounded-full bg-blush/80"
                      />
                      <span>{point}</span>
                    </li>
                  ))}
                </ul>

                <TagList items={job.skills} className="mt-7" />
              </div>
            </Reveal>
          </li>
        ))}
      </ol>
    </Section>
  );
}
